import React, { useState } from "react";
import { Container, Grid, Box } from "@mui/material";
import CcpSchoolBreadCrumbs from "../../Layout/CcpSchoolBreadCrumbs";
import HelpContent from "./inc/HelpContent";
import Faqs from "./inc/Faqs";
import { faInfo } from "@fortawesome/free-solid-svg-icons";

const CcpSchoolHelp = () => {
  const pageName = "Help & FAQs";
  const icon = faInfo;

  return (
    <Container sx={{ marginTop: "100px" }}>
      <Box sx={{ flexGrow: 1 }}>
        <CcpSchoolBreadCrumbs pageName={pageName} icon={icon} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <h4>Help & FAQ's</h4>
            <HelpContent />
          </Grid>
          <Grid item xs={12}>
            <Faqs />
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CcpSchoolHelp;
